import {
    Box, Button, Card, CardActionArea, CardMedia, Icon,
    Paper, Tooltip, Typography, useTheme,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    tableCellClasses, Autocomplete,
    CircularProgress,
    TextField, styled,
    Checkbox as MuiCheckBox,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    InputLabel,
    CardContent,
    CardActions,
    Collapse,
    IconButtonProps,
    IconButton,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { Enviroment } from "../../shered/enviroments";
import { EstatisticasService, IListaDadosJogadoresPowerRanking, IListaDadosPowerRankingFranquia } from "../../shered/services/api/estatisticas/EstatisticasService";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { Height } from "@mui/icons-material";

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
const melhoresFiltro = [
    {
        codigo: 1,
        label: "Todos"
    },
    {
        codigo: 2,
        label: "8 Melhores"
    },
    {
        codigo: 3,
        label: "6 Melhores"
    },
];

export const ListagemDePowerRanking: React.FC = () => {
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [estatisticasPowerRankingRows, setEstatisticasPowerRankingRows] = useState<IListaDadosPowerRankingFranquia[]>([]);
    const [totalCountJogadoresRanking, setTotalCountJogadoresRanking] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [filtroMelhores, setFiltroMelhores] = useState(1);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    //#region Variáveis dinâmicas
    const [expanded0, setExpanded0] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false);
    const [expanded2, setExpanded2] = React.useState(false);
    const [expanded3, setExpanded3] = React.useState(false);
    const [expanded4, setExpanded4] = React.useState(false);
    const [expanded5, setExpanded5] = React.useState(false);
    const [expanded6, setExpanded6] = React.useState(false);
    const [expanded7, setExpanded7] = React.useState(false);
    const [expanded8, setExpanded8] = React.useState(false);
    const [expanded9, setExpanded9] = React.useState(false);
    const [expanded10, setExpanded10] = React.useState(false);
    const [expanded11, setExpanded11] = React.useState(false);
    const [expanded12, setExpanded12] = React.useState(false);
    const [expanded13, setExpanded13] = React.useState(false);
    const [expanded14, setExpanded14] = React.useState(false);
    const [expanded15, setExpanded15] = React.useState(false);
    const [expanded16, setExpanded16] = React.useState(false);
    const [expanded17, setExpanded17] = React.useState(false);
    const [expanded18, setExpanded18] = React.useState(false);
    const [expanded19, setExpanded19] = React.useState(false);
    const [expanded20, setExpanded20] = React.useState(false);
    const [expanded21, setExpanded21] = React.useState(false);
    const [expanded22, setExpanded22] = React.useState(false);
    const [expanded23, setExpanded23] = React.useState(false);
    const [expanded24, setExpanded24] = React.useState(false);
    const [expanded25, setExpanded25] = React.useState(false);
    const [expanded26, setExpanded26] = React.useState(false);
    const [expanded27, setExpanded27] = React.useState(false);
    const [expanded28, setExpanded28] = React.useState(false);
    const [expanded29, setExpanded29] = React.useState(false);
    const [expanded30, setExpanded30] = React.useState(false);
    const [expanded31, setExpanded31] = React.useState(false);
    const [expanded32, setExpanded32] = React.useState(false);
    const [expanded33, setExpanded33] = React.useState(false);
    const [expanded34, setExpanded34] = React.useState(false);
    const [expanded35, setExpanded35] = React.useState(false);
    const [expanded36, setExpanded36] = React.useState(false);
    const [expanded37, setExpanded37] = React.useState(false);
    const [expanded38, setExpanded38] = React.useState(false);
    const [expanded39, setExpanded39] = React.useState(false);



    const [estatisticasJogadoresPowerRankingRows0, setEstatisticasJogadoresPowerRankingRows0] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows1, setEstatisticasJogadoresPowerRankingRows1] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows2, setEstatisticasJogadoresPowerRankingRows2] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows3, setEstatisticasJogadoresPowerRankingRows3] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows4, setEstatisticasJogadoresPowerRankingRows4] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows5, setEstatisticasJogadoresPowerRankingRows5] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows6, setEstatisticasJogadoresPowerRankingRows6] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows7, setEstatisticasJogadoresPowerRankingRows7] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows8, setEstatisticasJogadoresPowerRankingRows8] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows9, setEstatisticasJogadoresPowerRankingRows9] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows10, setEstatisticasJogadoresPowerRankingRows10] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows11, setEstatisticasJogadoresPowerRankingRows11] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows12, setEstatisticasJogadoresPowerRankingRows12] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows13, setEstatisticasJogadoresPowerRankingRows13] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows14, setEstatisticasJogadoresPowerRankingRows14] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows15, setEstatisticasJogadoresPowerRankingRows15] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows16, setEstatisticasJogadoresPowerRankingRows16] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows17, setEstatisticasJogadoresPowerRankingRows17] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows18, setEstatisticasJogadoresPowerRankingRows18] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows19, setEstatisticasJogadoresPowerRankingRows19] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows20, setEstatisticasJogadoresPowerRankingRows20] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows21, setEstatisticasJogadoresPowerRankingRows21] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows22, setEstatisticasJogadoresPowerRankingRows22] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows23, setEstatisticasJogadoresPowerRankingRows23] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows24, setEstatisticasJogadoresPowerRankingRows24] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows25, setEstatisticasJogadoresPowerRankingRows25] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows26, setEstatisticasJogadoresPowerRankingRows26] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows27, setEstatisticasJogadoresPowerRankingRows27] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows28, setEstatisticasJogadoresPowerRankingRows28] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows29, setEstatisticasJogadoresPowerRankingRows29] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows30, setEstatisticasJogadoresPowerRankingRows30] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows31, setEstatisticasJogadoresPowerRankingRows31] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows32, setEstatisticasJogadoresPowerRankingRows32] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows33, setEstatisticasJogadoresPowerRankingRows33] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows34, setEstatisticasJogadoresPowerRankingRows34] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows35, setEstatisticasJogadoresPowerRankingRows35] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows36, setEstatisticasJogadoresPowerRankingRows36] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows37, setEstatisticasJogadoresPowerRankingRows37] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows38, setEstatisticasJogadoresPowerRankingRows38] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);
    const [estatisticasJogadoresPowerRankingRows39, setEstatisticasJogadoresPowerRankingRows39] = React.useState<IListaDadosJogadoresPowerRanking[]>([]);


    //#endregion

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        handleCarregarDadosFiltros(1);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            })
        }
    }, []);

    const handleCarregarDadosFiltros = (tipoFiltro: number) => {
        setRemoveLoading(false);
        setIsLoading(true);
        setEstatisticasPowerRankingRows([]);
        for (let index = 0; index < 39; index++) {
            eval(`setEstatisticasJogadoresPowerRankingRows${index}([])`);
            eval(`setExpanded${index}(false)`);
        }
        setFiltroMelhores(tipoFiltro);
        EstatisticasService.getPowerRanking(Number(codigoLiga), tipoFiltro)
            .then((result) => {
                const lstDados = result.dado;
                setEstatisticasPowerRankingRows(lstDados);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setIsLoading(false);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 10 : 14
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: UtilidadeService.isMobile() ? 10 : 14,
            padding: "0px"
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 10 : 15
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            padding: UtilidadeService.isMobile() ? "4px 5px" : "4px 6px",
            Height: "37px"
        },
    }));

    const handleVerificarValoresTabela = (valor: any) => {
        if (valor !== undefined && valor !== null) {
            return valor.toFixed(3).replace(".", ",");
        }
        return 0;
    }

    const handleExpandClick = (index: number, code: number) => {
        setRemoveLoading(false);
        setIsLoading(true);
        if (eval(`expanded${index}`)) {
            eval(`setEstatisticasJogadoresPowerRankingRows${index}([])`);
        }
        eval(`setExpanded${index}(eval(!expanded${index}))`);
        EstatisticasService.getJogadoresPowerRanking(code, filtroMelhores)
            .then((result) => {
                const lstDados = result.dado;
                eval(`setEstatisticasJogadoresPowerRankingRows${index}(lstDados)`);

                setTotalCountJogadoresRanking(lstDados.length);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                //setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    };

    return (
        <LayoutBaseDePagina
            titulo={`Power Ranking - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })} />}>
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{xs:12, sm:12}} sx={{ width: "100%" }}>
                    <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2} >
                        <Grid container size={{xs:12, sm:12}} spacing={1}>
                            <Grid  size={{xs:12, sm:12}} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> Power Ranking </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial" spacing={2}>
                                <Grid  size={{xs:12, sm:3,md:3}} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={filtroMelhores}
                                            label="Melhores Jogadores"
                                            onChange={(e) => handleCarregarDadosFiltros(Number(e.target.value))}                                        >
                                            {/* <MenuItem value={0}>Selecione</MenuItem> */}
                                            {
                                                melhoresFiltro.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid  size={{xs:12, sm:12}}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid container size={{xs:12}}  >
                                {estatisticasPowerRankingRows.length > 0 && (
                                    <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="flex-start" >
                                        <Grid container size={{xs:10, sm:9}} display="flex" justifyContent="center" sx={{ padding: 1, paddingBottom: 1 }}>
                                            <Grid size={{xs:1, sm:1}} display="flex" justifyContent="center" alignSelf={"center"} >
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, fontWeight: "bold" }}>
                                                    {UtilidadeService.isMobile() ? "POS" : "POSIÇÃO"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{xs:2, sm:2}} display="flex" justifyContent="center" alignSelf={"center"}>
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, paddingRight: '5px', fontWeight: "bold" }}>
                                                    LOGO
                                                </Typography>
                                            </Grid>
                                            <Grid size={{xs:6, sm:6}} display="flex" justifyContent="start" alignSelf={"center"}>
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, fontWeight: "bold" }}>
                                                    FRANQUIA
                                                </Typography>
                                            </Grid>
                                            <Grid  size={{xs:3, sm:3}} display="flex" justifyContent="center" alignSelf="center">
                                                <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, fontWeight: "bold" }}>
                                                    PONTUAÇÃO
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        {estatisticasPowerRankingRows.length > 0 &&
                                            (
                                                estatisticasPowerRankingRows.map((m, i) => (
                                                    <Grid container key={i} size={{xs:12, sm:12}} display="flex" justifyContent="flex-start" >
                                                        <Card key={`Card${i}`} sx={{ width: "100%", boxShadow: "4", marginBottom: "5px" }}>
                                                            <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="flex-start"  >
                                                                <Grid  size={{xs:10, sm:11}} display="flex" justifyContent="flex-start" alignSelf={"center"}>
                                                                    <CardActionArea onClick={() => handleExpandClick(i, m.codigo)}>
                                                                        <CardContent sx={{ padding: 1 }}  >
                                                                            <Grid container size={{xs:12, sm:12, md:12}}>
                                                                                <Grid container size={{xs:12, sm:10, md:10, lg:10, xl:10}} display="flex" justifyContent="center"  >
                                                                                    <Grid size={{xs:1, sm:1}} display="flex" justifyContent="center" alignSelf={"center"}>
                                                                                        <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, fontWeight: "bold"}}>
                                                                                            {m.posicao}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid size={{xs:2, sm:2}} display="flex" justifyContent="center" alignSelf={"center"}>
                                                                                        <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingRight: '5px' }}>
                                                                                            <img src={m.logo != null ? m.logo : semImagemFranquia} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid size={{xs:6, sm:6}} display="flex" justifyContent="start" alignSelf={"center"}>
                                                                                        <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 16, fontWeight: "bold"}}>
                                                                                            {m.nome}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid  size={{xs:3, sm:3}} display="flex" justifyContent="center" alignSelf="center">
                                                                                        <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, fontWeight: "bold" }}>
                                                                                            {m.peso.toFixed(2)}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </CardContent>
                                                                    </CardActionArea>
                                                                </Grid>
                                                                <Grid size={{xs:2, sm:1}} display="flex" justifyContent="flex-start" alignSelf={"center"}>
                                                                    <CardActions disableSpacing >
                                                                        <ExpandMore
                                                                            key={m.codigo}
                                                                            expand={eval(`expanded${i}`)}
                                                                            onClick={() => handleExpandClick(i, m.codigo)}
                                                                            aria-expanded={eval(`expanded${i}`)}
                                                                            aria-label="Box Score"
                                                                        >
                                                                            <GridExpandMoreIcon sx={{ fontSize: UtilidadeService.isMobile() ? 16 : "auto", }} />
                                                                        </ExpandMore>
                                                                    </CardActions>
                                                                </Grid>
                                                            </Grid>
                                                            <Collapse in={eval(`expanded${i}`)} timeout="auto" unmountOnExit >
                                                                <CardContent >
                                                                    <Grid container size={{xs:12, sm:12}}   >
                                                                        <Grid  size={{xs:12, sm:12}} padding={1} boxShadow={4} style={{ backgroundColor: "#ffffff17" }}>
                                                                            <Typography paragraph sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 18, paddingTop: 2, fontWeight: 600 }}>ESTATÍSTICAS DOS JOGADORES NBA</Typography>
                                                                            <TableContainer component={Paper} variant="outlined" >
                                                                                <Table>
                                                                                    <TableHead sx={{ padding: UtilidadeService.isMobile() ? "2px" : "5px" }}>
                                                                                        <TableRow style={{ height: "37px"}}>
                                                                                            <StyledTableCell >FOTO</StyledTableCell>
                                                                                            <StyledTableCell>NOME</StyledTableCell>
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.min !== null) && <StyledTableCell align="center">{UtilidadeService.isMobile() ? "MIN" : "MINUTOS"}</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.ast !== null) && <StyledTableCell align="center">AST</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.blk !== null) && <StyledTableCell align="center">BLK</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.dreb !== null) && <StyledTableCell align="center">DREB</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.fga !== null) && <StyledTableCell align="center">FGA</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.fgm !== null) && <StyledTableCell align="center">FGM</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.fgmp !== null) && <StyledTableCell align="center">FGM%</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.fta !== null) && <StyledTableCell align="center">FTA</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.ftm !== null) && <StyledTableCell align="center">FTM</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.ftmp !== null) && <StyledTableCell align="center">FTM%</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.mplu !== null) && <StyledTableCell align="center">MPLU</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.oreb !== null) && <StyledTableCell align="center">OREB</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.pf !== null) && <StyledTableCell align="center">PF</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.pts !== null) && <StyledTableCell align="center">PTS</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.to !== null) && <StyledTableCell align="center">TO</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.reb !== null) && <StyledTableCell align="center">REB</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.stl !== null) && <StyledTableCell align="center">STL</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.threepa !== null) && <StyledTableCell align="center">3PA</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.threepm !== null) && <StyledTableCell align="center">3PM</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.threepmp !== null) && <StyledTableCell align="center">3PM%</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.fge !== null) && <StyledTableCell align="center">FGE</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.fte !== null) && <StyledTableCell align="center">FTE</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.threepe !== null) && <StyledTableCell align="center">THREEPE</StyledTableCell>}
                                                                                            {eval(`estatisticasJogadoresPowerRankingRows${i}`).find((f: IListaDadosJogadoresPowerRanking) => f.stocks !== null) && <StyledTableCell align="center">STOCKS</StyledTableCell>}
                                                                                            <StyledTableCell align="center">TOTAL</StyledTableCell>
                                                                                        </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                        {eval(`estatisticasJogadoresPowerRankingRows${i}`).map((row: IListaDadosJogadoresPowerRanking) => (
                                                                                            <StyledTableRow key={row.codigo} >
                                                                                                <StyledTableCell><img src={row.foto} alt={row.nome} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} /></StyledTableCell>
                                                                                                <StyledTableCell>{row.nome}</StyledTableCell>
                                                                                                {row.min !== null && <StyledTableCell align="center">{row.min.toFixed(0)}</StyledTableCell>}
                                                                                                {row.ast !== null && <StyledTableCell align="center">{(row.ast?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.blk !== null && <StyledTableCell align="center">{(row.blk?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.dreb !== null && <StyledTableCell align="center">{(row.dreb?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.fga !== null && <StyledTableCell align="center">{(row.fga?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.fgm !== null && <StyledTableCell align="center">{(row.fgm?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.fgmp !== null && <StyledTableCell align="center">{(row.fgmp?.toFixed(3))}</StyledTableCell>}
                                                                                                {row.fta !== null && <StyledTableCell align="center">{(row.fta?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.ftm !== null && <StyledTableCell align="center">{(row.ftm?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.ftmp !== null && <StyledTableCell align="center">{(row.ftmp?.toFixed(3))}</StyledTableCell>}
                                                                                                {row.mplu !== null && <StyledTableCell align="center">{(row.mplu?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.oreb !== null && <StyledTableCell align="center">{(row.oreb?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.pf !== null && <StyledTableCell align="center">{(row.pf?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.pts !== null && <StyledTableCell align="center">{(row.pts?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.to !== null && <StyledTableCell align="center">{(row.to?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.reb !== null && <StyledTableCell align="center">{(row.reb?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.stl !== null && <StyledTableCell align="center">{(row.stl?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.threepa !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.threepa)}</StyledTableCell>}
                                                                                                {row.threepm !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.threepm)}</StyledTableCell>}
                                                                                                {row.threepmp !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.threepmp)}</StyledTableCell>}
                                                                                                {row.fge !== null && <StyledTableCell align="center">{(row.fge?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.fte !== null && <StyledTableCell align="center">{(row.fte?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.threepe !== null && <StyledTableCell align="center">{(row.threepe?.toFixed(2))}</StyledTableCell>}
                                                                                                {row.stocks !== null && <StyledTableCell align="center">{(row.stocks?.toFixed(2))}</StyledTableCell>}
                                                                                                <StyledTableCell align="center">{row.peso_Total_Jogador?.toFixed(2)}</StyledTableCell>
                                                                                            </StyledTableRow >
                                                                                        ))
                                                                                        }
                                                                                    </TableBody>
                                                                                    {totalCountJogadoresRanking === 0 && !isLoading && (
                                                                                        <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                                    )}
                                                                                </Table>
                                                                            </TableContainer>
                                                                        </Grid>
                                                                    </Grid>
                                                                </CardContent>
                                                            </Collapse>
                                                        </Card>
                                                    </Grid>
                                                ))
                                            )}
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


